"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STANDALONE_VERSION = void 0;
var STANDALONE_VERSION = exports.STANDALONE_VERSION = "12.10-8"; // must match the version in scripts/standalone_data.json